import React from 'react'
import FAQsList from '@/components/FAQs/FAQsList'
import HealthAndSafetyFileList from '@/components/HealthAndSafetyFileList'
import { PageWrapper } from '@/components/__UI'
import { ContentContainer, Sidebar, InfoBox } from './HealthAndSafetyFaqPage.style'
import FAQs from '@/constants/faqs/faqs-health-and-safety'

const HealthAndSafetyFaqPage = () => {

  return (
    <PageWrapper
      title={`Health and Safety Information`}
    >
      <ContentContainer>
        <FAQsList
          style={{ flex: 1 }}
          showSearch
          faqData={FAQs || []}
          filter={'Health & Safety'}
        />
        <Sidebar>
          <HealthAndSafetyFileList />
          <InfoBox>
            <p>As a holiday-home owner, you have a duty of care to your guests and this involves making sure that your property complies with all relevant health and safety legislation and regulations. This forms part of your agreement with us and applies whether or not you use any third-party property maintenance services, such as a cleaner or caretaker. We hope the following is useful but for more comprehensive information, we recommend you visit the relevant websites which are linked within each section below. Kindly note that there may be other websites and resources for guidance and that we are not qualified to advise you about current regulations.</p>

            <p>As your agent, we are not responsible for ensuring that your property meets the requirements of the applicable  laws,  regulations  and  guidelines  however  we  have  provided  this  guidance  on  some  key health  and  safety  topics  for  you  to  consider.  For  more  comprehensive  information  we  suggest  you read the appropriate government guidance.</p>

            <p>Please note that we are not health and safety experts and that you are entirely responsible for the safety and suitability of your property for holiday letting. The information below is not an exhaustive list of your obligations but an indication of some key issues to be aware of.</p>

            <p>This is not an exhaustive guide, nor a definitive statement of the law. If further information on your legal requirements is required or if you have any queries we suggest you consult your legal advisor or another qualified expert.</p>
          </InfoBox>
        </Sidebar>
      </ContentContainer>
    </PageWrapper>
  )
}

export default HealthAndSafetyFaqPage
